/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateFacilityRegionRequest
 */
export interface CreateFacilityRegionRequest {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    facility_ids: Array<string>;
}

/**
 * Check if a given object implements the CreateFacilityRegionRequest interface.
 */
export function instanceOfCreateFacilityRegionRequest(value: object): value is CreateFacilityRegionRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('facility_ids' in value) || value['facility_ids'] === undefined) return false;
    return true;
}

export function CreateFacilityRegionRequestFromJSON(json: any): CreateFacilityRegionRequest {
    return CreateFacilityRegionRequestFromJSONTyped(json, false);
}

export function CreateFacilityRegionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityRegionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'facility_ids': json['facility_ids'],
    };
}

export function CreateFacilityRegionRequestToJSON(json: any): CreateFacilityRegionRequest {
    return CreateFacilityRegionRequestToJSONTyped(json, false);
}

export function CreateFacilityRegionRequestToJSONTyped(value?: CreateFacilityRegionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'facility_ids': value['facility_ids'],
    };
}

